import React from "react";
import DateHelper from "../../DateHelper/DateHelper";

class PortalReservationSegmentStatusDataType extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		var status = this.props.row.status;
    var date_format = DateHelper.rubyToDateFNS(this.props.row.date_format);
    var time_format = DateHelper.rubyToDateFNS(this.props.row.time_format);

    if (status === 'canceled') {
      var canceled_at = DateHelper.parseDateFromBackend(this.props.row.canceled_at);
      return <div>{I18n.t('cancelled_at', { date: DateHelper.printDateToScreen(canceled_at, date_format) + ' - ' + DateHelper.printDateToScreen(canceled_at, time_format, true) } )}</div>
    } else if (status === 'checked_in') {
    	var checked_in_at = DateHelper.parseDateFromBackend(this.props.row.checked_in_at);
    	return (
        <div>{I18n.t('checked_in_at', { date: DateHelper.printDateToScreen(checked_in_at, date_format) + ' - ' + DateHelper.printDateToScreen(checked_in_at, time_format, true)})}</div>
    	);
    } else if (status === 'checked_out') {
    	var checked_out_at = DateHelper.parseDateFromBackend(this.props.row.checked_out_at);
    	return (
        <div>{I18n.t('checked_out_at', { date: DateHelper.printDateToScreen(checked_out_at, date_format) + ' - ' + DateHelper.printDateToScreen(checked_out_at, time_format, true)})}</div>
    	);
    } else if (status == 'not_available_for_check_in'){
      return <div>{I18n.t(status) + ' - ' + DateHelper.printDateToScreen(this.props.row.check_in_date, date_format) + ' ' + DateHelper.printDateToScreen(DateHelper.parseDate(this.props.row.check_in_time), time_format)}</div>
    } else{
      return <div>{I18n.t(status)}</div>
    };
    
	};

};

export default PortalReservationSegmentStatusDataType
